export const SIZE_OF_EMPTY = 114
export const DEFAULT_EMPTY_TABLE_HEIGHT = 203
export const OFFSET_BOTTOM = DEFAULT_EMPTY_TABLE_HEIGHT - SIZE_OF_EMPTY + 16 * 3.75

export const getRowKey = (rowKey, isLoading) => (record) => {
    if (isLoading) {
        return record["__uuid"]
    }

    if (typeof rowKey === "function") {
        return rowKey(record)
    }

    if (rowKey) {
        return record[rowKey]
    }

    if ("key" in record) {
        return record["key"]
    }

    if ("id" in record) {
        return record["id"]
    }

    return record["__uuid"]
}
